import { Type } from '@hugendubel/ws_client';

type Availability = string;
export type EanAvailabilityMap = { [ean: string]: Availability };

export class WsStockInfo {
    eanAvailabilityMap: EanAvailabilityMap;

    constructor(eanAvailabilityMap: EanAvailabilityMap) {
        this.eanAvailabilityMap = eanAvailabilityMap;
    }

    static fromApi(json: any): WsStockInfo {
        Object.keys(json).forEach(key => Type.string(json[key], 'StockInfo.ean'));
        return new WsStockInfo(json);
    }
}
